<template>
  <section class="notice_edit">
    <helpCenterBar class="tab"></helpCenterBar>
    <div class="container">
      <div class="helpCenter">
          <s-title-header :mainTitle='docTitle' subTitle="帮助手册" :description="titleDes"></s-title-header>
          <!-- <S_button ></S_buttont> -->

          <!-- <s-button class=" edit_btn mt" v-if="$store.getters.roler==='admin'" @click.native="skipCn" width='138' height="40" color="#fff" ave="#276BEE" textWord="编辑" lineheight="40"></s-button> -->
      </div>
       <div class="edit_btn"><s-button class="fl" style="float:right" v-if="$store.getters.roler==='admin'" @click.native="skipCn" width=0.84 height=0.2 color="#fff" ave="#276BEE" textWord="编辑" lineHeight=0.2></s-button></div>
      <!--  -->
      <div class="content_area">
        <!-- 左侧导航 -->
        <div class="le">
          <div class="catalogue" id="category"></div>
        </div>
        <!-- 中间编辑框 -->
        <div class="ri">
          <div v-if="!isShowPic" class="edit_content" v-html="help_content"></div>
          <div class="pic" v-show="isShowPic" ><img src="../assets/noData.png" alt=""></div>
        </div>

        <!-- 右侧设置框 -->
        <!-- <div class="set_form">
          <div class="btn_bottom">
            <span class="save">
              <s-button v-if="$store.getters.roler==='admin'" @click.native="skipCn" width='138' height="40" color="#fff" ave="#276BEE" textWord="编辑" lineheight="40"></s-button>
            </span>
          </div>
        </div> -->
      </div>
    </div>

  </section>
</template>
<script>
import $ from 'jquery'
import Api from '@/api/api'
import HelpCenterBar from '@/components/HelpCenterBar'
import STitleHeader from '@/components/STitleHeader'
import SButton from '@/components/SButton'
export default {
  /******************************************
  ** 组件名称
  * @description 组件描述
  * @author ah
  *****************************************
  prop1          <type>            <属性描述>
  *****************************************/
  name: 'component_name',
  components: {HelpCenterBar, STitleHeader, SButton},
  props: {},
  data () {
    return {
      help_content: '',
      docTitle: '',
      titleDes: '',
      isShowPic: false
    }
  },
  computed: {},
  mounted () {
    // console.log(this.$route.params.id)
    // axios.get('http://192.168.1.161:7001/api/documents/' + this.$route.params.id).then(res => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     console.log(res.data)
    //     console.log('res.data')
    //     console.log(res.data.Result[0].Contents)
    //     this.help_content = res.data.Result[0].Contents
    //     this.docTitle = res.data.Result[0].Name
    //     this.titleDes = res.data.Result[0].Description
    //   }
    // })
    this.getData()
    // console.log($)
    this.scroll()
  },
  methods: {
    // 滚动一定高度固定
    scroll () {
      // 滑动到一定高度,固定tab栏
      $(window).scroll(function () {
        let scrollDistance = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // console.log(scrollDistance)
        if (scrollDistance >= 0) {
          $('.tab').addClass('fixtab')
        } else {
          $('.tab').removeClass('fixtab')
        }
        if (scrollDistance >= 120) {
          $('.edit_btn').addClass('fixbtn')
          $('.helpCenter').css('backgroundColor', '#fff')
        } else {
          $('.edit_btn').removeClass('fixbtn')
        }
        if (scrollDistance >= 200) {
          $('.catalogue').addClass('fixnav')
        } else {
          $('.catalogue').removeClass('fixnav')
        }
      }
      )
    },
    // 抽取标题
    getTitle () {
      // 标题序号计数器
      var hCount = [0, 0, 0, 0, 0, 0]
      // 设置计数器
      function setHCount (number) {
        // 当前计数器加一
        hCount[number - 1]++
        for (var i = number; i < hCount.length; i++) {
          // 子目录计数器全部置零
          hCount[i] = 0
        }
      }
      // 重命名目录名称
      function setHTagValue (item, number) {
        // 获取标题名
        var text = $(item).get(0).innerHTML
        // 初始化空字符串
        var before = ''
        // 生成序号
        for (var i = 0; i < number; i++) {
          if (i < number - 1) {
            before += hCount[i] + '.'
          } else {
            before += hCount[i] + ' '
          }
        }
        // 在标题前面加上序号
        $(item).get(0).innerHTML = before + text
      }
      function renameHTag (item) {
        var tag = $(item).get(0).localName
        if (tag === 'h1') {
          setHCount(1)
          // console\.log("捕获到标签:%s", tag);
          setHTagValue(item, 1)
        }
        if (tag === 'h2') {
          setHCount(2)
          // console.log("捕获到标签:%s", tag);
          setHTagValue(item, 2)
        }
        if (tag === 'h3') {
          setHCount(3)
          // console.log("捕获到标签:%s", tag);
          setHTagValue(item, 3)
        }
        if (tag === 'h4') {
          setHCount(4)
          // console.log("捕获到标签:%s", tag);
          setHTagValue(item, 4)
        }
        if (tag === 'h5') {
          setHCount(5)
          // console.log("捕获到标签:%s", tag);
          setHTagValue(item, 5)
        }
        if (tag === 'h6') {
          setHCount(6)
          // console.log("捕获到标签:%s", tag);
          setHTagValue(item, 6)
        }
      }
      $(document).ready(function () {
        $('h1,h2,h3,h4,h5,h6').each(function (i, item) {
          // 给<H>类标签编号
          renameHTag(item)
          // 获取标签的名字,h1,还是h2
          var tag = $(item).get(0).localName
          // 为该标签设置id属性
          $(item).attr('id', 'wow' + i)
          // 添加一个页内超链接,并设置class选择器
          //      $("#category").append('<a class="new'+tag+'" href=" '+i+'">'+$(this).text()+'</a ></br>');
          $('#category').append(`<a class="new${tag}" href="#wow${i}" title= "${$(item).text()}" >${$(item).text()}</a >`)
          // 为每一个标题超链接的class属性设置左边距
          $('.newh1').css('margin-left', 0)
          $('.newh2').css('margin-left', 20)
          $('.newh3').css('margin-left', 40)
          $('.newh4').css('margin-left', 40)
          $('.newh5').css('margin-left', 40)
          $('.newh6').css('margin-left', 40)
        })
        // 设置class选择器为.book-body的html内容
        // $('.edit_content').html($('.edit_content').nextAll())
        // $('.edit_content').html($('.edit_content'))
      })
    },

    // 获取该产品文档信息
    getData () {
      Api.getDoc(this.$route.params.id).then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.docTitle = res.data.Result[0].Name
          this.titleDes = res.data.Result[0].Description
          this.$store.dispatch('setRoler', res.data.role)
          this.getTitle()
          // 当没有文档信息时,即使用trim去掉字符串两边空格
          if ($.trim(res.data.Result[0].Contents).length === 0) {
            this.isShowPic = true
          } else {
            this.isShowPic = false
            this.help_content = res.data.Result[0].Contents
          }
        }
      })
        .catch(err => {
          console.log(err)
        })
    },
    skipCn () {
      this.$router.push({
        name: 'CheckNotice',
        params: {
          id: this.$route.params.id
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>

.container {
  width: 88%;
  // width: 1080px;
  margin:0 auto;
  height: 2.5rem;
  // height: 500px;
  position:relative;
  .helpCenter{
    position:relative;
    padding:0.4rem 0 0 0;
    width: 100%;
    height: 1rem;
    display:flex;
    justify-content: space-between;
    // .mt{
    //   margin-top: 120px;
    // }
    .edit_btn{
      width: 100%;
      // width: 1080px;
      height:0.2rem;
      // height:40px;
      margin-top:-0.25rem;
      // position:absolute;
      // top:250px;
      // left:0px;
      // float:right;
      // background-color: pink;
      .fl{
        float:right;
      }
    }
    .fixbtn{
      position: fixed;
      top: 100px;
      left: 22%;
      // margin-left: -520px;
      // padding-top: 30px;
      // margin-top:100px;
      // background-color: #fff;
      z-index:999;
      // background-color: #F7F7F7;
    }
  }
  .content_area{
    width: 100%;
    display: flex;
    // position: relative;
    // justify-content: space-between;
    box-sizing: border-box;
  .le{
    width: 30%;
    margin-right:0.26rem;
    box-sizing: border-box;
    .catalogue{
      // width: 220px;
      // height: 450px;
      width: 1.2rem;
      // height: 2.25rem;
      height: 100%;
      border-right: solid 1px #EAEAEA;
      overflow:auto;

    }
  }
  .ri{
    width: 64%;
    box-sizing: border-box;
    .edit_content{
      width:76%;
      // height: 1000px;
      // background-color: lightseagreen;
      padding-bottom:0.5rem;
      h1{
        font-size:0.16rem!important;
      }
      p{
        font-size:0.06rem!important;
      }
      img{
        max-width:2rem!important;
        margin:0.1rem 0!important;
      }
    }
    .pic {
      // width:154px ;
      // height: 140px;
      width:0.77rem ;
      height: 0.7rem;
      // position:absolute;
      margin:0 auto;
      // position: absolute;
      // top: 200px;
      // left: 600px;
      margin-top:26%;
      margin-left:36%;
      img{
        width: 100%;
        height: 100%;
      }

    }

  }

    /* tab栏固定效果 */
    .fixnav {
      position: fixed;
      top: 30px;
      left: 49%;
      margin-left: -520px;
      padding-top: 30px;
      z-index:666;
      background-color: #fff;
    }

    .set_form{
      // background-color: pink;

      // width:168px;
      // height: 240px;
      width:0.84rem;
      height: 1.2rem;
      box-sizing: border-box;
        .btn_right{
          width: 100%;
          .cancel,.save{
            display: block;
            margin-bottom:0.1rem;
          }
        }
  }
}
}
.fixtab{
   position: fixed;
  top: 0px;
  left: 0px;
  // margin-left: -520px;
  // padding-top: 30px;
  z-index:999;
  background-color: #F7F7F7;
}

</style>



// WEBPACK FOOTER //
// src/pages/DocManage.vue